import axios from '@/utils/request'
import * as common from '@/api/common'

export function getList(params) {
  return axios.get('/admin_api/v1/query/school/', {
    params
  })
}

// 院校属性-详情
export function getAttributeDetail(uuid) {
  return axios.get('/admin_api/v1/query/school/' + uuid + '/attribute/')
}

// 院校属性-编辑
export function editAttribute(uuid, data) {
  return axios.put('/admin_api/v1/query/school/' + uuid + '/attribute/', data)
}

// 院校属性-研究生院-列表
export function getGraduateList(school_uuid, params) {
  return axios.get('/admin_api/v1/query/school/' + school_uuid + '/graduate/', {
    params
  })
}
// 院校属性-研究生院-添加
export function addGraduate(school_uuid, data) {
  return axios.post('/admin_api/v1/query/school/graduate/' + school_uuid + '/', data)
}

// 院校属性-研究生院-编辑
export function editGraduate(uuid, data) {
  return axios.put('/admin_api/v1/query/school/graduate/' + uuid + '/', data)
}

// 院校属性-研究生院-删除
export function delGraduate(uuid) {
  return axios.delete('/admin_api/v1/query/school/graduate/' + uuid + '/')
}

// 院校简介-详情
export function getIntroductionDetail(uuid) {
  return axios.get('/admin_api/v1/query/school/' + uuid + '/introduction/')
}

// 院校简介-编辑
export function editIntroduction(uuid, data) {
  return axios.put('/admin_api/v1/query/school/' + uuid + '/introduction/', data)
}

// 院校简介-重点建设学科-列表
export function getDisciplineList(school_uuid, params) {
  return axios.get('/admin_api/v1/query/school/' + school_uuid + '/key-discipline/', {
    params
  })
}

// 院校简介-重点建设学科-添加
export function addDiscipline(school_uuid, data) {
  return axios.post('/admin_api/v1/query/school/' + school_uuid + '/key-discipline/', data)
}

// 院校简介-重点建设学科-编辑
export function editDiscipline(uuid, data) {
  return axios.put('/admin_api/v1/query/school/key-discipline/' + uuid + '/', data)
} 

// 院校简介-重点建设学科-删除
export function delDiscipline(uuid) {
  return axios.delete('/admin_api/v1/query/school/key-discipline/' + uuid + '/')
}

// 院校简介-重点建设学科-批量导入
export function importDiscipline(school_uuid) {
  return common.baseURL() + '/admin_api/v1/query/school/' + school_uuid + '/key-discipline/import/'
}


// 院校简介-历年学费-列表获取
export function getTuitionList(school_uuid, year, params) {
  return axios.get('/admin_api/v1/query/school/' + school_uuid + '/' + year + '/tuition/', {
    params
  })
}

// 院校简介-历年学费-详情
export function getTuitionDetail(tuition_id) {
  return axios.get('/admin_api/v1/query/school/tuition/' + tuition_id + '/')
}

// 院校简介-历年学费-添加
export function addTuition(school_uuid,  year, data) {
  return axios.post('/admin_api/v1/query/school/' + school_uuid + '/' + year + '/tuition/', data)
}

// 院校简介-历年学费-编辑
export function editTuition(uuid, data) {
  return axios.put('/admin_api/v1/query/school/tuition/' + uuid + '/', data)
}

// 院校简介-历年学费-删除
export function delTuition(uuid) {
  return axios.delete('/admin_api/v1/query/school/tuition/' + uuid + '/')
}

// 院校简介-历年学费-清空
export function clearTuition(school_uuid,  year) {
  return axios.delete('/admin_api/v1/query/school/' + school_uuid + '/' + year + '/tuition/clear/')
}

// 院校简介-历年学费-批量导入
export function importTuition(school_uuid, year) {
  return common.baseURL() + '/admin_api/v1/query/school/' + school_uuid + '/' + year + '/tuition/import/'
}


// 知名导师-列表获取
export function getTeacherList(school_uuid, params) {
  return axios.get('/admin_api/v1/query/school/' + school_uuid + '/teacher/', {
    params
  })
}

// 知名导师-添加
export function addTeacher(school_uuid, data) {
  return axios.post('/admin_api/v1/query/school/' + school_uuid + '/teacher/', data)
}

// 知名导师-编辑
export function editTeacher(uuid, data) {
  return axios.put('/admin_api/v1/query/school/teacher/' + uuid + '/', data)
}

// 知名导师-删除
export function delTeacher(uuid) {
  return axios.delete('/admin_api/v1/query/school/teacher/' + uuid + '/')
}

// 知名导师-批量导入
export function importTeacher(school_uuid) {
  return common.baseURL() + '/admin_api/v1/query/school/' + school_uuid + '/teacher/import/'
}


// 知名校友-列表获取
export function getAlumnusList(school_uuid, params) {
  return axios.get('/admin_api/v1/query/school/' + school_uuid + '/alumnus/', {
    params
  })
}

// 知名校友-添加
export function addAlumnus(school_uuid, data) {
  return axios.post('/admin_api/v1/query/school/' + school_uuid + '/alumnus/', data)
}

// 知名校友-编辑
export function editAlumnus(uuid, data) {
  return axios.put('/admin_api/v1/query/school/alumnus/' + uuid + '/', data)
}

// 知名校友-删除
export function delAlumnus(uuid) {
  return axios.delete('/admin_api/v1/query/school/alumnus/' + uuid + '/')
}

// 知名校友-批量导入
export function importAlumnus(school_uuid) {
  return common.baseURL() + '/admin_api/v1/query/school/' + school_uuid + '/alumnus/import/'
}

// 报考分析-获取详情
export function getAnalysisDetail(uuid) {
  return axios.get('/admin_api/v1/query/school/' + uuid + '/analysis/')
}

// 报考分析-编辑
export function editAnalysis(uuid, data) {
  return axios.put('/admin_api/v1/query/school/' + uuid + '/analysis/', data)
}

// 附加项目-报考条件-获取详情
export function getConditionDetail(uuid) {
  return axios.get('/admin_api/v1/query/school/' + uuid + '/condition/')
}

// 附加项目-报考条件-编辑
export function editCondition(uuid, data) {
  return axios.put('/admin_api/v1/query/school/' + uuid + '/condition/', data)
}

// 附加项目-报考限制条件-列表获取
export function getLimitList(school_uuid, params) {
  return axios.get('/admin_api/v1/query/school/' + school_uuid + '/limit/', {
    params
  })
}

// 附加项目-报考限制条件-添加
export function addLimit(school_uuid, data) {
  return axios.post('/admin_api/v1/query/school/' + school_uuid + '/limit/', data)
}

// 附加项目-报考限制条件-编辑
export function editLimit(uuid, data) {
  return axios.put('/admin_api/v1/query/school/limit/' + uuid + '/', data)
}

// 附加项目-报考限制条件-删除
export function delLimit(uuid) {
  return axios.delete('/admin_api/v1/query/school/limit/' + uuid + '/')
}

// 附加项目-名企列表-列表获取
export function getEnterpriseList(school_uuid, params) {
  return axios.get('/admin_api/v1/query/school/' + school_uuid + '/enterprise/', {
    params
  })
}

// 附加项目-名企列表-添加
export function addEnterprise(school_uuid, data) {
  return axios.post('/admin_api/v1/query/school/' + school_uuid + '/enterprise/', data)
}

// 附加项目-名企列表-编辑
export function editEnterprise(uuid, data) {
  return axios.put('/admin_api/v1/query/school/enterprise/' + uuid + '/', data)
}

// 附加项目-名企列表-删除
export function delEnterprise(uuid) {
  return axios.delete('/admin_api/v1/query/school/enterprise/' + uuid + '/')
}

// 附加项目-名企列表-批量导入
export function importEnterprise(school_uuid) {
  return common.baseURL() + '/admin_api/v1/query/school/' + school_uuid + '/enterprise/import/'
}

// 附加项目-平均薪资-获取详情
export function getSalaryDetail(uuid) {
  return axios.get('/admin_api/v1/query/school/' + uuid + '/salary/')
}

// 附加项目-平均薪资-编辑
export function editSalary(uuid, data) {
  return axios.put('/admin_api/v1/query/school/' + uuid + '/salary/', data)
}

// 附加项目-中外合作-列表获取
export function getCooperativeList(school_uuid, params) {
  return axios.get('/admin_api/v1/query/school/' + school_uuid + '/cooperative/', {
    params
  })
}

// 附加项目-中外合作-添加
export function addCooperative(school_uuid, data) {
  return axios.post('/admin_api/v1/query/school/' + school_uuid + '/cooperative/', data)
}

// 附加项目-中外合作-编辑
export function editCooperative(uuid, data) {
  return axios.put('/admin_api/v1/query/school/cooperative/' + uuid + '/', data)
}

// 附加项目-中外合作-删除
export function delCooperative(uuid) {
  return axios.delete('/admin_api/v1/query/school/cooperative/' + uuid + '/')
}

// 附加项目-重点实验室-列表获取
export function getLaboratoryList(school_uuid, params) {
  return axios.get('/admin_api/v1/query/school/' + school_uuid + '/laboratory/', {
    params
  })
}

// 附加项目-重点实验室-添加
export function addLaboratory(school_uuid, data) {
  return axios.post('/admin_api/v1/query/school/' + school_uuid + '/laboratory/', data)
}

// 附加项目-重点实验室-编辑
export function editLaboratory(uuid, data) {
  return axios.put('/admin_api/v1/query/school/laboratory/' + uuid + '/', data)
}

// 附加项目-重点实验室-删除
export function delLaboratory(uuid) {
  return axios.delete('/admin_api/v1/query/school/laboratory/' + uuid + '/')
}

